module.exports = __webpack_public_path__ + "static/media/ucLogoBW.368ea946.png";